<template>
     <!--理论学习标签-->
     <div class="sy-llxx">
        <span>{{title}}</span>
        <img class='llxx-bq' src="@/assets/images/btbq.png">
        <el-link v-if="!hideMore"
          class="more"
          type="info"
          :href="to"
          target="_blank"
        >
          查看更多
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#iconmore"></use>
          </svg>
        </el-link>
      </div>
</template>

<script>

export default {
   props:['title','hideMore','to']
}
</script>

<style>
 .sy-llxx > span{
    font-weight: 700;
    font-size: 36px;
    color: #BD1A2D;

}
.sy-llxx{
    width: 1200px;
    height: 50px;
    margin: auto;

}
.sy-llxx .llxx-bq{
    /* width: 925px; */
    height: 10px;
    display: inline-block;
    vertical-align:5px;
    line-height: 50px;
    margin: 0 8px 0 27px;
}
.sy-llxx .more.posa{
    top: 42px;
    right: 0;
}
</style>